import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';

import { homeFaqs as faqs } from '@/lib/seo/homeFaqs';


export default function HomeFAQ() {

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <HelpCircle className="w-4 h-4" />
            Common Questions
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-slate-800 mb-4">
            Frequently Asked Questions About <span className="font-serif italic text-amber-700">Dental Implants in Trinity, FL</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Clear answers about dental implants, costs, candidacy and the next step at Trinity Dental Arts
          </p>
        </motion.div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <details key={faq.question} className="group bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
              <summary className="cursor-pointer w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-50 transition-colors">
                <span className="font-semibold text-slate-800 text-base pr-4">{faq.question}</span>
                <ChevronDown aria-hidden="true" className="w-5 h-5 text-amber-600 flex-shrink-0 transition-transform duration-300 group-open:rotate-180" />
              </summary>
              <p className="px-6 pb-5 text-slate-600 leading-relaxed">{faq.answer}</p>
            </details>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
          className="mt-10 text-center"
        >
          <p className="text-slate-600 mb-4">Still have questions?</p>
          <a
            href="tel:+17272286846"
            aria-label="Call (727) 228-6846"
            className="inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold px-8 py-3 rounded-full transition-colors"
          >
            Call (727) 228-6846
          </a>
        </motion.div>
      </div>
    </section>
  );
}